export default {
    // ========== Button and Sidebar ==========
    pinMenu: 'Pin menu',
    unpinMenu: 'Unpin menu',
    artificialIntelligence: 'Artificial Intelligence',
    artificialIntelligenceSubtitle: 'Generate suggestions for one curricular element at a time.',

    // ========== Tabs ==========
    generator: 'Generator',
    results: 'Results',
    options: 'Options',
    advancedOptions: 'Advanced options',
    closeAdvancedOptions: 'Close advanced options',

    // ========== Selectors ==========
    whatToCreate: 'What do you want to create?',
    selectOption: '-- Select an option --',
    select: 'Select',
    select2: 'Selected',
    selectA: 'Select a',
    selectEntity: 'Seleccione a {entity}',
    selectedEntity: '{entity} selected',
    willBeConsidered: 'Will be considered the',
    toGenerate: 'to generate the',
    noResultsFor: 'No results found for',

    // ========== Context and Examples ==========
    from: 'from the',
    of: 'of the',
    of2: 'of',
    generates: 'generates',
    example: 'example',
    examples: 'examples',
    question: 'question',
    questions: 'questions',
    writeAdditionalContext: 'Write additional context...',
    availableCharacters: 'Available characters',

    // ========== Amount of Examples ==========
    selectAmountExamples: 'Select the number of examples you want to generate.',

    // ========== Buttons ==========
    generateExamples: 'Generate examples',

    // ========== Advanced Options ==========
    temperature: 'Temperature',
    temperatureTooltip: 'Controls the randomness of results. Low values make responses more predictable, while high values generate more creative responses.',
    tokensAmount: 'Number of tokens to use',
    tokensTooltip: 'Limits the maximum number of tokens (unit of words and word fragments) that the response can contain.',

    // ========== Results ==========
    generatingExamples: 'Generating examples...',
    noExamplesGenerated: 'No examples have been generated yet.',
    copyAllResults: 'Copy all results.',
    clickToCopy: 'Click to copy the content.',

    // ========== Toast Messages ==========
    exampleCopied: 'Example copied to clipboard',
    allExamplesCopied: 'All examples have been copied to clipboard',

    // ========== Error Messages ==========
    aiAccessBlocked: 'AI access blocked',
    inappropriateUseDetected: 'Inappropriate use of AI has been detected. Your access will be temporarily restricted.',
    accept: 'Accept',
    lengthLimitReached: 'Generation reached the maximum length limit. The examples shown are incomplete.',
    couldNotDetermineResult: 'Could not determine a complete result. Please adjust the parameters and try again.',
    contentFilterError: 'An error occurred with the response as the content is considered inappropriate or sensitive.',
    generationError: 'An error occurred while generating the examples. Please try again.',
    serverCommunicationError: 'Server communication error.',

    // ========== Dynamic context ==========
    evaluationIndicator: 'an {entity}',
    evaluationIndicators: '{entity}',

    // ========== Pre-textarea phrases ==========
    fromThe: 'from the following',
    andThe: 'and the',
    forThe: 'For the',

    // ========== AI Prompts (promptRubricAchievement method) ==========
    // Each prompt is a single sentence/string (no concatenated fragments).
    dimensionLevelPrompt: '{dimensionEntity} {dimension}, {levelEntity} {level} generate me a description',
    dimensionCriteriaPrompt: 'Guided by this {indicatorEntity}: {indicator} Only respond with {text} in format: Verb, Object, Condition. With verbs from Marzano and Kendall Taxonomy. Make sure the verbs are in third person singular.',
    questionPrompt: '{subjectEntity}: {subject}, Guided by this {indicatorEntity}: {indicator}, Only respond with Question Suggestions that are written as performance-based for the {evaluationEntity} according to the following context: {context}',
    contentPrompt: 'Generate thematic content for the {subjectEntity} {subject}, considering the following {learningOutcomeEntity}: {learningOutcome}.\nPresent an organized list by topics and subtopics (for example: Topic 1, 1.1, 1.2; Topic 2, 2.1, 2.2).\nDeliver only the content titles, without development or methodology.\nonly generate {amount} topics with their respective subtopics.',
    competenceCyclePrompt: '{egressProfileEntity}: {egressProfileName}, Guided by this {competenceEntity}: {competence}, belonging to {cycleEntity} {cycleName}. Only respond with {text} for the cycle: {cycleActual}, in format: Verb, Object, Condition, Context, with verbs from levels 4-6 of Marzano and Kendall Taxonomy. With verbs from Marzano and Kendall Taxonomy. Make sure the verbs are in third person singular.',
    bibliographyPrompt: '{subjectEntity}: {subject}, Bibliography of type: {bibliographyName}, Only respond with Bibliographies in {format} format',

    // ========== Bibliographic Resources ==========
    selectType: 'Select a type',
    selectFormat: 'Select APA format',
    selectFormatPlaceholder: 'Select a format',
}
